import React from 'react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { messages as platformMessages } from '@xengage/gw-platform-translations';
import { FormModalPopover } from 'ml-components-platform-react';
import metadata from './PrivacyPolicyComponent.metadata.json5';
import styles from './PrivacyPolicyComponent.module.scss';
import messages from './PrivacyPolicyComponent.messages';
import content from './PrivacyPolicyContent.metadata.json5';
import MLLinks from '../../../../../quote-and-buy/src/config/ml-links.json';
import appConfig from 'app-config';

function PrivacyPolicyComponent(props) {
    const {
        showLinksOnly, 
        showDividers, 
        vertialLinks,
        hideHyperlink
    } = props;

    const isQnB = appConfig.portalCode === 'QB';

    const resolvers = {
        resolveClassNameMap: styles
    };

    const overrides = {
        privacyPolicyLink: {
            visible: hideHyperlink,
            href: MLLinks.farmersPrivacyPolicy,
            target: '_blank',
            className: isQnB ? "privacyPolicyQnB" : "link-override"
        },
        collectionOfPersonalInfoLink: {
            visible: hideHyperlink,
            href: MLLinks.useOfPersonalInfo,
            target: '_blank',
            className: isQnB ? "privacyPolicyQnB" : "link-override"
        },
        doNotSellLink: {
            visible: hideHyperlink,
            href: MLLinks.farmersDoNotSellLink,
            target: '_blank',
            className: isQnB ? "privacyPolicyQnB" : "link-override"
        },
        agreeAndContinueText: {
            visible: !showLinksOnly,
            className: isQnB ? "privacyPolicyQnB" : ""
        },
        divider1: {
            visible: !!showDividers
        },
        divider2: {
            visible: !!showDividers
        },
        comma: {
            visible: !showDividers && !vertialLinks,
            className: isQnB ? "privacyPolicyQnB" : ""
        },
        commaAnd: {
            visible: !showDividers && !vertialLinks,
            className: isQnB ? "privacyPolicyQnB" : ""
        },
        linksForMoreInformation: {
            visible: !showLinksOnly,
            className: isQnB ? "privacyPolicyQnB" : "link-override"
        },
        break1: {
            visible: !!vertialLinks
        },
        break2: {
            visible: !!vertialLinks
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

export default PrivacyPolicyComponent;
